import { FormIds } from '@utils/enums/FormIds.enum';
import patientDetailsForm from '../forms/patientDetails';
import contactDetailsForm from '../forms/contactsDetails';
import useMergeForm from './useMergeForm';
import { FormBuilderObOptions } from '@components/FormBuilder/FormBuilder.ob';
import { useMemo } from 'react';
import useCustomTranslation from './useCustomTranslation';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

interface FormFieldsRequest {
  formIds: Array<FormIds>;
  patientIndex: number;
  optionsList?: Array<FormBuilderObOptions>;
}

const useGetFormFields = ({
  formIds,
  optionsList,
  patientIndex,
}: FormFieldsRequest) => {
  const { t } = useCustomTranslation();
  const { mergePatientDetails, createCustomFields, mergeContactsDetails } =
    useMergeForm();

  const brandName = useOnlineBookingStore(state => state.brandName);
  const toReturn = useMemo(
    () =>
      formIds.map((formId, index) => {
        const options = optionsList ? optionsList[index] : null;
        switch (formId) {
          case FormIds.PatientDetail:
            return {
              data: mergePatientDetails(
                patientDetailsForm(
                  t,
                  options &&
                    options.countryList &&
                    options.countryStatesList &&
                    options.genderList
                    ? {
                        countryList: options.countryList,
                        countryStatesList: options.countryStatesList,
                        genderList: options.genderList,
                        readOnlyPrefilledPatientsDetailsFields:
                          options.readOnlyPrefilledPatientsDetailsFields,
                        prefilledPatientDetailsFields:
                          options.prefilledPatientDetailsFields,
                      }
                    : undefined,
                  !!brandName,
                ),
                patientIndex,
              ),
            };
          case FormIds.CustomPage:
            return {
              data: createCustomFields('storeCustomFieldsCustomPage', formId),
            };
          case FormIds.CustomFieldsPatient:
            return {
              data: createCustomFields(
                'patientDetails.storeCustomFieldsPatient',
                formId,
                true,
              ),
            };
          case FormIds.CustomFieldsInsurance:
            return {
              data: createCustomFields(
                'patientDetails.storeCustomFieldsInsurance',
                formId,
                true,
              ),
            };
          case FormIds.ContactInformation:
            return {
              data: mergeContactsDetails(contactDetailsForm(t)),
            };
          default:
            return {
              data: [],
            };
        }
      }),
    [
      brandName,
      createCustomFields,
      formIds,
      mergeContactsDetails,
      mergePatientDetails,
      optionsList,
      patientIndex,
      t,
    ],
  );
  return toReturn;
};

export default useGetFormFields;
